import React from 'react';
import { Flex, Typography } from '@slope/uikit';

export interface ErrorStateProps {
  title?: string;
  message?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'Error',
  message = 'Algo salió mal. Por favor, inténtalo de nuevo más tarde.',
}) => {
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: '50vh' }}
    >
      <Typography fontSize="24px" fontWeight="bold" color="red">
        {title}
      </Typography>
      <Typography fontSize="16px" mt="0.5rem">
        {message}
      </Typography>
    </Flex>
  );
};
